import { CnaAchComponent } from "./CnaAchComponent";

export function CnaAchScreen() {
  return (
    <>
      <CnaAchComponent />
    </>
  );
}
